import { render, staticRenderFns } from "./DepartmentDocuments.vue?vue&type=template&id=91ec7848&scoped=true&"
import script from "./DepartmentDocuments.vue?vue&type=script&lang=js&"
export * from "./DepartmentDocuments.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentDocuments.vue?vue&type=style&index=0&id=91ec7848&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ec7848",
  null
  
)

export default component.exports